<template>
<div class="af3-shortcode-one-pager-background"></div>
<div class="af3-shortcode-one-pager-content-container">
      <div class="af3-shortcode-one-pager-content">
          <h2 v-html="options.one_pager_title"></h2>  
          <div class="af3-shortcode-one-pager-description" v-html="options.one_pager_description"></div>
          <div class="af3-shortcode-one-pager-content-accordion-container">
            <div v-for="(floorplans, key) in rows" :key="key" class="af3-shortcode-one-pager-content-accordion">
              <button class="af3-shortcode-one-pager-content-button" @click="toggleFloorplans(key)" :aria-expanded="activeFloorplans === key" :class="{ 'active': activeFloorplans === key }">
                <span class="af3-shortcode-one-pager-content-button-title">{{ handleBedroomString(key) }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="11.304" height="6.713" viewBox="0 0 11.304 6.713"><path d="M9.713,5.652,5.122,1.061.53,5.652-.53,4.591,5.122-1.061l5.652,5.652Z" transform="translate(10.773 5.652) rotate(180)"/></svg>
              </button>
              <ul>
              <li class="af3-shortcode-one-pager-content-accordion-floorplans" v-for="floorplan in floorplans" :key="floorplan.id" v-show="activeFloorplans === key" :aria-hidden="activeFloorplans !== key">
                <button class="af3-shortcode-one-pager-content-accordion-floorplans-button" :class="{ 'af3-shortcode-one-pager-content-accordion-floorplans-button-active': activeFloorplan === floorplan.post_id }" @click="toggleFloorplan(floorplan.post_id)">
                  <span class="af3-shortcode-one-pager-content-accordion-floorplans-title" v-html="floorplan.title"></span>
                  <div class="af3-shortcode-one-pager-content-accordion-floorplans-units-available">
                    {{ handleUnitsAvailableString(floorplan.available_units) }}
                    <a :href="floorplan.availability_url" v-if="floorplan.availability_url && floorplan.available_units > 0" target="_blank" class="af3-shortcode-one-pager-content-accordion-floorplans-button-apply">
                      <span>Apply Now</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22.825" height="21.096" viewBox="0 0 22.825 21.096"><g transform="translate(-204.506 -455.578)"><path d="M9.667,20.865.223,11.1a.439.439,0,0,1-.037-.042h0l-.01-.013h0l-.009-.011h0l-.008-.011h0l-.007-.01v-.006L.146,11V10.99l0-.008,0-.009v-.007l-.006-.01v-.005L.1,10.932h0l-.008-.015h0a.8.8,0,0,1,.131-.926L9.667.23a.744.744,0,0,1,1.077,0,.807.807,0,0,1,0,1.113L2.6,9.761H22.066a.787.787,0,0,1,0,1.573H2.6l8.145,8.418a.807.807,0,0,1,0,1.113.745.745,0,0,1-1.077,0Z" transform="translate(227.331 476.673) rotate(180)"/></g></svg>
                    </a>
                  </div>
                </button>
              </li>
              </ul>
            </div>
          </div>
        </div>
      <div class="af3-shortcode-one-pager-gallery ">
        <OnePagerGalleryComponent :floorplan="activeFloorplanObject" />
      </div>
</div>


</template>
  
<script>

import OnePagerGalleryComponent from './OnePagerGalleryComponent.vue';

import { defineComponent, ref, watch, onMounted, reactive, onUnmounted } from 'vue';


export default defineComponent({
    components: { OnePagerGalleryComponent },
   
    props: { 
        options: {
            type: Object,
            required: true
        },
        rows: {
            type: Array,
            required: true
        }
     },

    setup(props) {

     
      

      const activeFloorplans = ref(Object.keys(props.rows)[0]);
      const activeFloorplan = ref(props.rows[activeFloorplans.value][0].post_id);
      const activeFloorplanObject = ref(props.rows[activeFloorplans.value].find(floorplan => floorplan.post_id === activeFloorplan.value));
      const toggleFloorplans = (key) => {
        activeFloorplans.value = key;
        activeFloorplan.value = props.rows[key][0].post_id;
        activeFloorplanObject.value = props.rows[key].find(floorplan => floorplan.post_id === activeFloorplan.value);
      }

      const toggleFloorplan = (post_id) => {
        activeFloorplan.value = post_id;
        activeFloorplanObject.value = props.rows[activeFloorplans.value].find(floorplan => floorplan.post_id === post_id);
      }

      const handleBedroomString = (key) => {
        if (key == 0) {
          return 'Studio';
        } else {
          return key + (key == 1 ? ' Bedroom' : ' Bedrooms');
        }
      }

      const handleUnitsAvailableString = (units) => {
        if (units == 0) {
          return 'Sold Out';
        } else {
          return units + (units == 1 ? ' Unit Available' : ' Units Available');
        }
      }
          
    return {
        handleUnitsAvailableString,
        handleBedroomString,
        activeFloorplans,
        activeFloorplan,
        toggleFloorplans,
        toggleFloorplan,
        activeFloorplanObject
    };
  },


  
  
});
</script>

